export const GET_ADMIN_DASHBOARD_DATA = 'GET_ADMIN_DASHBOARD_DATA'
export const GET_DROPDOWN_CONCIERGES_DATA = 'GET_DROPDOWN_CONCIERGES_DATA'
export const GET_DROPDOWN_RESTAURANT_DATA = 'GET_DROPDOWN_RESTAURANT_DATA'
export const GET_CONCIERGE_RESTAURANT_STATS_DATA = 'GET_CONCIERGE_RESTAURANT_STATS_DATA'
export const GET_UNAPPROVED_CONCIERGE_RESTAURANT_DATA = 'GET_UNAPPROVED_CONCIERGE_RESTAURANT_DATA'
export const GET_DASHBOARD_RESTAURANT = 'GET_DASHBOARD_RESTAURANT'
export const GET_DASHBOARD_CONCIERGE = 'GET_DASHBOARD_CONCIERGE'